﻿import { eventBus } from '../../foundation/eventBus';
import { events as menuEvents } from './burger-menu';

export const globalHeader = () => {
    const selectors = {
        rootOpen: 'global-header--open'
    };

    const _offCanvasHeaderToggle = (el) => {
        el.classList.toggle(selectors.rootOpen);  
    };

    const init = component => {
        eventBus.subscribe(menuEvents.offCanvasNav, function () {
            _offCanvasHeaderToggle.call(null, component);
        });
    };

    return {
        init: init,
        selector: '.global-header'
    };
};